"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isFilter = (type) => type === 'filter';
exports.default = isFilter;
